import { app_placeholder } from '../../../env.placeholders';
import { HttpArcgis } from '../../http';
import { LocalStorage } from '../../localStorage';
import { defineDefinitionExpression, prepareMultipleInseeCodesRequest } from '../map/defExpHelper';

// get linear of all cummunes or a commune or a bc selected
export const findLinear = (pGeoFilter: any, pLinears: any[]) => {
  const geoFilter = pGeoFilter;
  let length = 0;
  // no spatial filter
  if (geoFilter.code === '') {
    pLinears.forEach((linear) => {
      if (linear.type === 'commune') {
        length += linear.linear;
      }
    });
  } else {
    // spécific choise : bc or commune
    pLinears.forEach((linear) => {
      if (
        (linear.type === 'commune' && linear.inseeCode === geoFilter.code) ||
        (linear.type === 'bc' && linear.inseeCode === geoFilter.name)
      ) {
        length += linear.linear;
      }
    });
  }
  return length;
};

export const defineCommuneOrCollectionPoolFilter = (
  pFilterBcOrCommune: any,
  pAllInseeCodesContract: any,
  pMode: string,
  pQuery: string,
) => {
  let inseeCodeFilter = '';
  // custom filter between bc and communes
  if (pFilterBcOrCommune.mode === 'bc') {
    inseeCodeFilter = pFilterBcOrCommune.data[pMode] !== '' ? 'OBJECTID in (' + pFilterBcOrCommune.data[pMode] + ')' : '';
  } else {
    inseeCodeFilter = pQuery.includes('InseeCode') === false ? 
      'InseeCode in (' +
      prepareMultipleInseeCodesRequest(pAllInseeCodesContract) +
      ')' : '';
  }
  return inseeCodeFilter;
};

// request to get stats
export const createFormBodyHydroStats = (pLayerDef: string, pMode: string) => {
  const formBody: string[] = [];
  formBody.push('where=' + pLayerDef);
  const groupBy = pLayerDef.includes('CollectionPoolCode') ? 'CollectionPoolCode' : 'InseeCode';
  formBody.push('groupByFieldsForStatistics='+groupBy);
  if (pMode === 'debouchage' || pMode === 'black_point') {
    formBody.push('returnGeometry=false');
    formBody.push(
      'outStatistics=%5B%0D%0A%7B%0D%0A++++"statisticType"%3A+"count"%2C%0D%0A++++"onStatisticField"%3A+"OBJECTID"%2C%0D%0A++++"outStatisticFieldName"%3A+"CountByCommune"%0D%0A++%7D%0D%0A%5D'
    );
  } else {
    formBody.push('outFields=InseeCode,Length');
    formBody.push(
      'outStatistics=%5B%0D%0A%7B%0D%0A++++"statisticType"%3A+"sum"%2C%0D%0A++++"onStatisticField"%3A+"Length"%2C%0D%0A++++"outStatisticFieldName"%3A+"Length"%0D%0A++%7D%0D%0A%5D'
    );
  }
  formBody.push('f=json');
  formBody.push('user=' + LocalStorage.userMail.get());
  const formBodyToSend = formBody.join('&');
  return formBodyToSend;
};

export const getDebouchageStats = async (pSpatialFilter: string) => {
  let datas = [];
  // prepare queries
  const pLayerDef =
    pSpatialFilter +
    " AND WorkTypeCode in ('8400')";
  const formBodyToSend = createFormBodyHydroStats(pLayerDef, 'debouchage');

  try {
    // launch request
    const responseSections = await HttpArcgis.post(
      app_placeholder.VITE_APP_ARCGIS_SERVER + '?path=/303/query',
      JSON.stringify(formBodyToSend)
    );
    if (
      responseSections.status === 200 &&
      responseSections.data.features !== undefined
    ) {
      datas = responseSections.data.features;
    } else {
      console.log('Aucune données !');
    }
  } catch (error) {
    console.log('Failed to get data for debouchage !', error);
  }
  return datas;
};

export const getDataForTable = async (pExtent: any, pLayerDef: string) => {
  // prepare queries
  const bbox =
    pExtent.xmin + ',' + pExtent.ymin + ',' + pExtent.xmax + ',' + pExtent.ymax;

  // form for request sevice
  const formBody: string[] = [];
  formBody.push('where=' + pLayerDef);
  formBody.push('returnGeometry=false');
  formBody.push('geometryType=esriGeometryEnvelope');
  formBody.push('inSR=102100');
  formBody.push('geometry=' + bbox);
  formBody.push(
    'groupByFieldsForStatistics=WorkTypeGroup%2C+YearFromCurrentYear,WorkTypeLabel'
  );
  formBody.push(
    'outStatistics=%5B%0D%0A%7B%0D%0A++++"statisticType"%3A+"count"%2C%0D%0A++++"onStatisticField"%3A+"OBJECTID"%2C%0D%0A++++"outStatisticFieldName"%3A+"CountByYear"%0D%0A++%7D%0D%0A%5D'
  );
  formBody.push('f=json');
  formBody.push('user=' + LocalStorage.userMail.get());
  const formBodyToSend = formBody.join('&');
  let datas: any[] = [];

  try {
    // launch request
    const responseSections = await HttpArcgis.post(
      app_placeholder.VITE_APP_ARCGIS_SERVER + '?path=/303/query',
      JSON.stringify(formBodyToSend)
    );
    if (
      responseSections.status === 200 &&
      responseSections.data.features !== undefined
    ) {
      datas = responseSections.data.features;
    } else {
      console.log('Aucune données !');
      datas = [];
    }
  } catch (error) {
    console.log('Failed to get data for table !', error);
    datas = [];
  }
  return datas;
};

export const createDataForTable = (pDataTable: any) => {
  const distinct = (value, index, self) => {
    return self.indexOf(value) === index;
  };

  // get dinstinc values for type
  let typesToDistinct: string[] = [];
  pDataTable.forEach((result: any) => {
    typesToDistinct.push(result['attributes'].WorkTypeGroup);
  });
  const distinctWorkTypeGroup = typesToDistinct.filter(distinct);

  // get result group by type
  let typeValuesToDistinct: any[] = [];
  distinctWorkTypeGroup.forEach((type: any) => {
    typeValuesToDistinct.push(
      pDataTable.filter((d) => d['attributes'].WorkTypeGroup === type)
    );
  });

  // get dinsctinc values for year
  let yearsToDistinct: string[] = [];
  pDataTable.forEach((result: any) => {
    yearsToDistinct.push(result['attributes'].YearFromCurrentYear);
  });
  const distinctYearFromCurrentYear = yearsToDistinct.filter(distinct);

  // get result groupe by year
  let typeByYearsValuesToDistinct: any[] = [];
  distinctYearFromCurrentYear.forEach((year: any) => {
    typeValuesToDistinct.forEach((t: any) => {
      typeByYearsValuesToDistinct.push(
        t.filter((d) => d['attributes'].YearFromCurrentYear === year)
      );
    });
  });

  // get reulst group by type and year
  let dataForTable: any[] = [];
  typeByYearsValuesToDistinct.forEach((byYear: any[any]) => {
    if (byYear.length > 0) {
      let line: any = {
        CountByYear: 0,
        WorkTypeGroup: byYear[0]['attributes'].WorkTypeGroup,
        YearFromCurrentYear: byYear[0]['attributes'].YearFromCurrentYear,
      };
      byYear.forEach((t: any) => {
        line.CountByYear += t['attributes'].CountByYear;
      });
      dataForTable.push(line);
    }
  });
  return dataForTable;
};

// calculate indicator for debouchage
export const getNbDebouchage = async (
  pFilterBcOrCommune: any,
  pDebouchageByCommune: any,
  pAllInseeCodesContract: any,
  pAssetDefinitionExpression: string
) => {
  let count = 0;
  const spatialFilter = defineCommuneOrCollectionPoolFilter(
    pFilterBcOrCommune,
    pAllInseeCodesContract,
    'inter',
    pAssetDefinitionExpression
  );
  let dataForDebouchage;
  if (pFilterBcOrCommune.mode === 'bc') {
    // get stats for collection pool
    dataForDebouchage = await getDebouchageStats(spatialFilter);
    if (dataForDebouchage.length !== 0) {
      count = dataForDebouchage[0]['attributes'].CountByCommune;
    }
  } else {
    // stats already found for all communes
    const filter = pFilterBcOrCommune.data;
    dataForDebouchage = pDebouchageByCommune.find((commune: any) =>
      commune['attributes'].InseeCode.includes(filter.replaceAll("'", ''))
    );
    if (dataForDebouchage !== undefined) {
      // specific commune selected by user
      count = dataForDebouchage['attributes'].CountByCommune;
    } else {
      // for all commune case
      pDebouchageByCommune.forEach((commune: any) => {
        count += commune['attributes'].CountByCommune;
      });
    }
  }
  return count;
};

export const requestGetObjectids = async (pQuery: string, pInputGeom: any, pServiceId: string) => {
  let data: string = '';
  // form for request sevice
  const formBody: string[] = [];
  formBody.push('where=' + pQuery);
  formBody.push('geometry=' + JSON.stringify(pInputGeom));
  formBody.push('geometryType=esriGeometryPolyline');
  formBody.push('spatialRel=esriSpatialRelContains');
  formBody.push('distance=100');
  formBody.push('units=esriSRUnit_Meter');
  formBody.push('outFields=OBJECTID');
  formBody.push('returnGeometry=false');
  formBody.push('f=json');
  formBody.push('user=' + LocalStorage.userMail.get());
  const formBodyToSend = formBody.join('&');

  try {
    // launch request
    const responseSections = await HttpArcgis.post(
      app_placeholder.VITE_APP_ARCGIS_SERVER + '?path=/'+pServiceId+'/query',
      JSON.stringify(formBodyToSend)
    );
    const datas = responseSections.data;
    datas.features?.forEach((feat: any, index: number) => {
      // get geometry for zoom
      let toConcat = feat['attributes'].OBJECTID;
      if (index === 0) {
        data = toConcat;
      } else {
        data = data + ',' + toConcat;
      }
    });
  } catch (error) {
    console.log(
      'Failed to get data for getting objectids for collection pool !',
      error
    );
  }
  return data;
};

export const getObjectIdsInterForBcSelected = async (
  pFiltres: any,
  pQuery: any
) => {
  // prepare queries
  let data: string = '';
  let inputGeom;
  // BC or Commune selected
  if (pFiltres['InseeCode'].paths !== undefined) {
    inputGeom = {
      hasM: true,
      paths: pFiltres['InseeCode'].paths,
      spatialeReference: {
        wkid: 4326,
      },
    };
  } else {
    return null;
  }

  // form for request sevice
  data = await requestGetObjectids(pQuery, inputGeom, '303');

  return data;
};

export const getObjectIdsBlackPointsForBcSelected = async (
  pFilters: any,
  pQuery: string
) => {
  // prepare queries
  let data: string = '';
  let inputGeom;
  // BC or Commune selected
  if (pFilters['InseeCode'].paths !== undefined) {
    inputGeom = {
      hasM: true,
      paths: pFilters['InseeCode'].paths,
      spatialeReference: {
        wkid: 4326,
      },
    };
  } else {
    return null;
  }

  data = await requestGetObjectids(pQuery, inputGeom, '306');
  
  return data;
};

export const avoidOutfieldsForBlackPoints = (pQuery: string) => {
  let query = pQuery;
  const querySplitted = query.split('AND');
  if(querySplitted !== undefined) {
    const queryWithoutSpecificOutfields = querySplitted.filter((q: string) => {
      return q.includes('WorkTypeLabel') === false && q.includes('WorkTypeGroup') === false;
    }
    );
    return queryWithoutSpecificOutfields.join('AND');
  } else {
    return query;
  }
}

export const createSpatialFilter = async (
  pFilters: any,
  pAllBc: any[],
  pAllInseeCodesContract: any[],
  pQuery: string,
) => {
  // define if bc or commune selected
  let filteBcOrCommune;
  let bcOrCommune: string = 'commune';
  let insee;
  // init insee
  if (pFilters['InseeCode'].paths) {
    // find the BC slected in all BC find for the contract
    let res = pAllBc.find((bc) => bc.name === pFilters['InseeCode'].name);
    insee = res.paths;
    bcOrCommune = 'bc';
  } else if (pFilters['InseeCode'].code !== '') {
    insee = "'" + pFilters['InseeCode'].code + "'";
  } else {
    // if a commune is selected
    insee = prepareMultipleInseeCodesRequest(pAllInseeCodesContract);
  }

  // create object for commune filter
  if (bcOrCommune === 'bc') {
    // we use geometries of collection pool to get objectids of interventions and black points
    // then finally get stats by using objectids
    let response_inter = await getObjectIdsInterForBcSelected(pFilters, pQuery);
    
    let response_blackPoint = await getObjectIdsBlackPointsForBcSelected(
      pFilters, avoidOutfieldsForBlackPoints(pQuery)
    );

    filteBcOrCommune = {
      mode: bcOrCommune,
      data: { inter: response_inter, blackPoint: response_blackPoint },
    };
  } else {
    // we use InseeCode for updating layers
    filteBcOrCommune = { mode: bcOrCommune, data: insee };
  }
  return filteBcOrCommune;
};

// create new def exp for black point layer
export const updateDefExpForBlackPointLayer = (pFilters: string, pSpatialFilter: any) => {
  let defExpUpdated = pFilters;
  let and = 'AND';
  if (pFilters === '') {
    and = '';
  }
  // if commune is selected
  if (pSpatialFilter.mode === 'commune' && defExpUpdated.includes('InseeCode') === false) {
    defExpUpdated += and + ' InseeCode in (' + pSpatialFilter.data + ')';
  } else {
    const defExpSplitted = defExpUpdated.includes('OBJECTID') === true ? defExpUpdated.split('AND OBJECTID')[0] : defExpUpdated;
    defExpUpdated = avoidOutfieldsForBlackPoints(defExpSplitted);
    // if collection pool selected
    if (
      pSpatialFilter.data['blackPoint'] !== '' &&
      defExpUpdated.includes('InseeCode') === false
    ) {
      defExpUpdated +=
        'AND OBJECTID in (' + pSpatialFilter.data['blackPoint'] + ')';
    }
  }
  return defExpUpdated;
};

export const getNbBlackPoints = async (pQuery: string) => {
  const formBodyToSend = createFormBodyHydroStats(avoidOutfieldsForBlackPoints(pQuery), 'black_point');
  let datas = [];
  try {
    // launch request
    const responseSections = await HttpArcgis.post(
      app_placeholder.VITE_APP_ARCGIS_SERVER + '?path=/306/query',
      JSON.stringify(formBodyToSend)
    );
    if (
      responseSections.status === 200 &&
      responseSections.data.features !== undefined
    ) {
      datas = responseSections.data.features;
    } else {
      console.log('Aucune données !');
    }
  } catch (error) {
    console.log('Failed to get data for debouchage !', error);
  }
  return datas;
};

export const calculateBlackPoint = async (pDefExp: string, pFilters: string) => {
  let nbBlackPoint = 0;
  const defineDefExp = pDefExp.includes('OBJECTID') === false ? pDefExp : "CollectionPoolCode in ('" + pFilters + "')";
  const nbBlackPoints = await getNbBlackPoints(defineDefExp);
  nbBlackPoints.forEach((blackpoint: any) => {
    nbBlackPoint += blackpoint['attributes'].CountByCommune;
  });
  return nbBlackPoint;
};

export const calculateDebouchage = async (
  pAsset: any,
  pBcAndCommuneHydro: any,
  pFilters: object,
  pModule: string,
  pSessionContractCode: string,
  pAllInseeCodesContract: any[],
  pLinears: any
) => {
  let defineDefExp;
  if (pBcAndCommuneHydro.mode === 'bc') {
    defineDefExp = pAsset.definitionExpression !== null ? pAsset.definitionExpression.split('AND')[2] : defineDefExp = 'OBJECTID in (' + pBcAndCommuneHydro.data + ')';
  } else {
    defineDefExp = defineDefinitionExpression(
      pFilters,
      pModule,
      pSessionContractCode
    );
  }
  // get all nb of debouchage for all communes
  const dataForDebouchage = await getDebouchageStats(defineDefExp);

  // calcul indicator for debouchage
  let newIndicator = 0;
  let count = 0;
  let length = 0;
  if (
    pBcAndCommuneHydro.data &&
    (pBcAndCommuneHydro.data.inter !== undefined ||
      pBcAndCommuneHydro.data.inter !== '')
  ) {
    count = await getNbDebouchage(
      pBcAndCommuneHydro,
      dataForDebouchage,
      pAllInseeCodesContract,
      pAsset.definitionExpression
    );
    length = findLinear(
      JSON.parse(window.sessionStorage.getItem('hydro_commune')!) || {
        name: '',
        code: '',
        paths: '',
      },
      pLinears
    );
    if (count !== 0) {
      newIndicator = count / (length / 1000);
    }
  }

  return { newIndicator: newIndicator, count: count, length: length };
};

export const provideDataForHydroTable = async (pExtent: any, pDefExp: string) => {
  // update table
  const details = await getDataForTable(
    pExtent,
    pDefExp
  );
  const dataFormated = createDataForTable(details);
  // transform data for table
  let data: any[] = [];
  dataFormated.forEach((line: any, index: number) => {
    let year = new Date().getFullYear() - line.YearFromCurrentYear;
    data.push({
      id: index,
      year: line.YearFromCurrentYear,
      type: line.WorkTypeGroup,
      effectif: line.CountByYear,
      label: line.WorkTypeGroup + ' - ' + year,
    });
  });
  return {
    dataTable: data, 
    details: details
  };
};